export default __webpack_public_path__ + "static/media/8.d0ccf5f0.jpg";